import { all, fork, put } from 'typed-redux-saga';

import { ChannelHolder } from '../../helpers/channelHolder';
import { deviceManager } from '../goloom-sdk';
import { resetDeviceError, ResetDeviceErrorPayload, setDeviceError, SetDeviceErrorPayload } from './slice';

export function* setDeviceManagerErrorSaga(payload: SetDeviceErrorPayload) {
    yield* put(setDeviceError(payload));
}

export function* resetDeviceManagerErrorSaga(payload: ResetDeviceErrorPayload) {
    yield* put(resetDeviceError(payload));
}

export function* waitForDeviceManagerInit() {
    if (deviceManager.sessionPreview) {
        return;
    }

    const channelHolder = new ChannelHolder();
    try {
        return yield* channelHolder.take(deviceManager.onInit);
    } finally {
        channelHolder.close();
    }
}

export function* rootDeviceManager() {
    const channelHolder = new ChannelHolder();

    try {
        yield all([
            fork([deviceManager, deviceManager.init]),
            channelHolder.takeEvery(deviceManager.onError, setDeviceManagerErrorSaga),
            channelHolder.takeEvery(deviceManager.onResetError, resetDeviceManagerErrorSaga),
        ]);
    } finally {
        channelHolder.close();
    }
}
